module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.changeTheme
    },
    model: {
      value: (_vm.tabPosition),
      callback: function($$v) {
        _vm.tabPosition = $$v
      },
      expression: "tabPosition"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "店铺券",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "活动券",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "幸运购券",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "推广券",
      "name": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex",
      "padding": "20px 0 0 20px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入优惠券名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.yhqName),
      callback: function($$v) {
        _vm.yhqName = $$v
      },
      expression: "yhqName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabPosition == '3'),
      expression: "tabPosition == '3'"
    }],
    staticStyle: {
      "display": "flex",
      "width": "25%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.hdName),
      callback: function($$v) {
        _vm.hdName = $$v
      },
      expression: "hdName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("优惠券")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabPosition != '3'),
      expression: "tabPosition != '3'"
    }],
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.addCoupon
    }
  }, [_vm._v("新 增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.couponList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.tabPosition == '3') ? _c('el-table-column', {
    key: "1",
    attrs: {
      "label": "活动名称",
      "align": "center",
      "min-width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.title))]
      }
    }], null, false, 1628289981)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    key: "2",
    attrs: {
      "label": "券名称",
      "align": "center",
      "min-width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "3",
    attrs: {
      "label": "面值(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.faceValue))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "4",
    attrs: {
      "label": "使用门槛",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.useThreshold))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "5",
    attrs: {
      "label": "有效期",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.startTime) + "-" + _vm._s(scope.row.endTime))]
      }
    }])
  }), _vm._v(" "), (_vm.tabPosition != '2') ? _c('el-table-column', {
    attrs: {
      "label": "售价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.price))])]
      }
    }], null, false, 1386323907)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发放数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.stock))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "领取数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.receiveCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核销数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          style: ({
            color: scope.row.useCount == 0 ? '#ccc' : '#6786b4'
          }),
          on: {
            "click": function($event) {
              return _vm.activeNum(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.useCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "转换率",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.convertRate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state == 1),
            expression: "scope.row.state == 1"
          }],
          staticClass: "spanList"
        }, [_vm._v("未开启")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state == 2),
            expression: "scope.row.state == 2"
          }],
          staticClass: "spanList"
        }, [_vm._v("已开启")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state == 3),
            expression: "scope.row.state == 3"
          }],
          staticClass: "spanList"
        }, [_vm._v("已关闭")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state == 4),
            expression: "scope.row.state == 4"
          }],
          staticClass: "spanList"
        }, [_vm._v("已过期")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.tabPosition != '3' && scope.row.state == 1) ? _c('span', {
          staticClass: "operationButton",
          on: {
            "click": function($event) {
              return _vm.Turnonoff(scope.row, scope.row.state)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-check"
        }), _vm._v("开启\r\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tabPosition != '3' && scope.row.state == 2) ? _c('span', {
          staticClass: "operationButton",
          on: {
            "click": function($event) {
              return _vm.Turnonoff(scope.row, scope.row.state)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-circle-close"
        }), _vm._v("关闭\r\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tabPosition != '3' && scope.row.state == 1) ? _c('span', {
          staticClass: "operationButton",
          on: {
            "click": function($event) {
              return _vm.editDetails(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "operationButton",
          on: {
            "click": function($event) {
              return _vm.seeInfo(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看\r\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "转化订单",
      "custom-class": "registrationRecord",
      "visible": _vm.activeOrderDrawer,
      "direction": "rtl",
      "size": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.activeOrderDrawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "dataDescription"
  }, [_c('span', [_vm._v("总订单数："), _c('b', [_vm._v(_vm._s(_vm.orderStatistics.OrderCount))]), _vm._v(",")]), _vm._v(" "), _c('span', [_vm._v(" 订单总金额："), _c('b', [_vm._v(_vm._s(_vm.orderStatistics.OrderPrice) + " 元")]), _vm._v(",")]), _vm._v(" "), _c('span', [_vm._v(" 认购总数："), _c('b', [_vm._v(_vm._s(_vm.orderStatistics.GrantCount))]), _vm._v(",")]), _vm._v(" "), _c('span', [_vm._v(" 转换率："), _c('b', [_vm._v(_vm._s(_vm.orderStatistics.ConvertOrderRate) + " %")])])]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.conversionList
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "Name",
      "label": "用户昵称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "Phone",
      "label": "用户电话",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "OrderNo",
      "label": "订单号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "Price",
      "label": "订单金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "CTime",
      "label": "支付时间",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.conversionPageIndex,
      "total": _vm.conversionTotal
    },
    on: {
      "current-change": _vm.handleConversion
    }
  })], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "custom-class": "registrationRecord",
      "visible": _vm.seeDetails,
      "size": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.seeDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "drawer_title"
        }, [_vm._v(_vm._s(_vm.couponDetails.Name))])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawerDiv"
  }, [_c('div', {
    staticClass: "zhaungtai"
  }, [_vm._v(_vm._s(_vm.couponDetails.StateName))]), _vm._v(" "), _c('p', [_vm._v("优惠券信息")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("售价："), _c('span', [_vm._v(_vm._s(_vm.couponDetails.Price))])]), _vm._v(" "), _c('li', [_vm._v("优惠券面值："), _c('span', [_vm._v(_vm._s(_vm.couponDetails.FaceValue))])]), _vm._v(" "), _c('li', [_vm._v("使用门槛："), _c('span', [_vm._v(_vm._s(_vm.couponDetails.UseExplain))])]), _vm._v(" "), _c('li', [_vm._v("有效时间："), _c('span', [_vm._v(_vm._s(_vm.couponDetails.EffectiveDate))])]), _vm._v(" "), _c('li', [_vm._v("每人领取："), _c('span', [_vm._v(_vm._s(_vm.couponDetails.ReceiveNumber))])])]), _vm._v(" "), _c('p', {
    staticClass: "specialInstructions"
  }, [_vm._v("优惠券特殊说明")]), _vm._v(" "), _c('ul', {
    staticClass: "richText"
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.couponDetails.SpecialInstructions)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("领取记录")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.registrationRecordList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "username",
      "label": "领取用户",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "gettime",
      "label": "领取时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "statename",
      "label": "状态",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.subscriptionPageIndex,
      "total": _vm.subscriptionTotal
    },
    on: {
      "current-change": _vm.handleSubscription
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    on: {
      "change": _vm.changeDianpu
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fe4c47c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/couponList.vue
// module id = 1663
// module chunks = 3